/**
 * Module definition for states module. The states module manages
 * the application's top-level states view (i.e., /states).
 *
 * @module routes.cases.states
 */

angular.module('routes.cases.states', [
  'stack',
  'routes.cases.states.constants',
  'routes.cases.states.StatesController',
  'routes.cases.states.StatesPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.cases.states', {
          url: '/states/:stateId?:stateMode',
          templateUrl: 'routes/cases/states/states.html',
          controller: 'StatesController',
          params: {
            stateId: { value: null, squash: true },
            stateMode: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'STATES',
              function (ConstantResolver, STATES) {
                return new ConstantResolver(STATES);
              }
            ],
            statesPayload: [
              'StatesPayloadResolver',
              '$stateParams',
              'casesPayload',
              function (StatesPayloadResolver, $stateParams, casesPayload) {
                return new StatesPayloadResolver($stateParams, casesPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
